import {
  TeamInvite,
  WebSocketAction,
  WebSocketEntityType,
} from '@this+that/models';
import log from 'loglevel';

import type { IEventEmitter } from '../EventEmitter';
import { WebSocketEventType } from '../WebSocketContext';

export function createTeamInviteMessageHandler(eventEmitter: IEventEmitter) {
  return (action: WebSocketAction, item: TeamInvite) => {
    try {
      switch (action) {
        case WebSocketAction.INSERT:
          log.debug(`[TeamInviteHandler] INSERT TeamInvite ${item.teamId}`);
          eventEmitter.emit(
            WebSocketEntityType.TeamInvite,
            WebSocketEventType.INSERT,
            item,
          );
          break;
        case WebSocketAction.MODIFY:
          log.debug(`[TeamInviteHandler] MODIFY TeamInvite ${item.teamId}`);
          eventEmitter.emit(
            WebSocketEntityType.TeamInvite,
            WebSocketEventType.MODIFY,
            item,
          );
          break;
        case WebSocketAction.REMOVE:
          log.debug(`[TeamInviteHandler] REMOVE TeamInvite ${item.teamId}`);
          eventEmitter.emit(
            WebSocketEntityType.TeamInvite,
            WebSocketEventType.REMOVE,
            item,
          );
          break;
        default:
          log.warn(
            '[TeamInviteHandler] Unknown action for TeamInvite:',
            action,
          );
      }
    } catch (error) {
      log.error('[TeamInviteHandler] Handler failed:', error);
    }
  };
}
